export type QuoteFormConfigurationFields = {
    name: string
    label: string
    type: string
    rank: number
    required: boolean
    hide: boolean
    isCustomField: boolean
    subFields: QuoteFormConfiguration[]
}
export type QuoteFormConfigurationDto = {
    id: string,
    type: string,
    attributes: QuoteFormConfigurationFields,
}

export default class QuoteFormConfiguration {
    private dto: QuoteFormConfigurationDto

    constructor(dto: QuoteFormConfigurationDto) {
        this.dto = dto
    }

    getId(): string {
        return this.dto.id
    }

    getType(): string {
        return this.dto.type
    }

    getAttributes() {
        return this.dto.attributes || []
    }

    setAttributes(field, value) {
        this.dto.attributes[field] = value
    }

    getSubFields(): QuoteFormConfiguration[] {
        return this.dto.attributes.subFields
    }



}



// WEBPACK FOOTER //
// ./src/state/ecommerce-configuration/EcommerceQuoteFormConfiguration.ts